import { useMutation, useQuery } from '@tanstack/react-query';
import type { PricingCriteriaResponse, PricingRequest, PricingResponse } from '@carrierbridge/shared';
import api from '@/lib/api';

export function usePricingQuote() {
  return useMutation({
    mutationFn: async (request: PricingRequest) => {
      const { data } = await api.post<PricingResponse>('/pricing/quote', request);
      return data;
    },
  });
}

/**
 * Périmètres des grilles qui peuvent coter ce trajet, à cette date et cette
 * quantité : de quoi ne proposer, sur le formulaire de devis, que les critères
 * (type de marchandises, incoterm…) qui débloquent une grille.
 *
 * `request` est la cotation SANS les critères — ils sont ce qu'on cherche à
 * choisir. Nul tant que le trajet n'est pas complet : rien ne part. La réponse
 * précédente reste affichée pendant le rechargement, pour que le bloc de
 * critères ne clignote pas à chaque modification du formulaire.
 */
export function usePricingCriteria(request: PricingRequest | null) {
  return useQuery<PricingCriteriaResponse>({
    queryKey: ['pricing', 'criteria', request],
    queryFn: async () => {
      const { data } = await api.post<PricingCriteriaResponse>('/pricing/criteria', request);
      return data;
    },
    enabled: request !== null,
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });
}
